// extracted by mini-css-extract-plugin
export default {"single-bill":"single-bill_single-bill__7vJ39","single-bill__main":"single-bill_single-bill__main__xtU7d","single-bill__main__col":"single-bill_single-bill__main__col__jh1CQ"};